<eb-form
  #formComponent
  *ngIf="formConfig$ | async as formConfig"
  [formConfig]="formConfig"
  context="userProfile"
>
  <a [routerLink]="{ cxRoute: 'homepage' } | cxUrl" class="eb-update-profile-form__back-button">
    {{ 'userProfile.backToHome' | cxTranslate }}
  </a>
</eb-form>
